'use client'

import { ComponentProps, ReactNode } from 'react'

import { cn } from '@/shared/lib'
import { Carousel } from '@/shared/ui'

type RootProps = ComponentProps<typeof Carousel.Provider> & {
  children: ReactNode
}

export const Root = ({
  className,
  children,
  options = {},
  useAutoPlay,
  ...props
}: RootProps) => {
  return (
    <div className="max-w-screen">
      <Carousel.Provider
        orientation="horizontal"
        options={{ loop: true, ...options }}
        useAutoPlay={useAutoPlay}
      >
        <Carousel.Root
          className={cn('mx-auto mb-7.5 w-fit max-w-full')}
          {...props}
        >
          <Carousel.Content className={cn('ml-0', className)}>
            {children}
          </Carousel.Content>
          <Carousel.DotButton
            className="-bottom-7 gap-1"
            dotClassName="h-1 w-1 bg-black/50 focus-visible:ring-0"
          />
        </Carousel.Root>
      </Carousel.Provider>
    </div>
  )
}

export const Item = ({
  children,
  className,
  ...props
}: ComponentProps<typeof Carousel.Item>) => {
  return (
    <Carousel.Item {...props} className={cn('basis-auto pl-3.5', className)}>
      {children}
    </Carousel.Item>
  )
}
